<template>
  <div>


        <van-field :value="hesap.kad" label="İsim" disabled />
        <van-field :value="hesap.session" label="Login" disabled />
        <van-field :value="hesap.kmail" type="mail" label="E-Posta" />
        <van-field :value="hesap.entegrekodu" label="Yetki" disabled />
        <van-field :value="hesap.kullanicidepoAlias" label="Depom" disabled />
        <van-field :value="hesap.token * 858990" type="text"  disabled  label="Token" />
        <!-- <van-field v-model="password" type="password" label="Password" /> -->

        <!-- <van-field v-model="isim" label="İsim" disabled />
        <van-field v-model="kadi" label="Login" disabled />
        <van-field v-model="tel" type="number" label="Telefon" />
        <van-field v-model="posta" type="mail" label="E-Posta" />
        <van-field v-model="yetki" label="Yetki" disabled />
        <van-field v-model="defaultdepo" label="Depom" disabled />
        <van-field v-model="digit" type="text"  disabled  label="Token" />
        <van-field v-model="password" type="password" label="Password" /> -->
        <!-- <van-button size="large" @click="update()" style="margin-bottom:10px"   type="default">GÜNCELLE</van-button> -->
        <!-- <van-button size="large" @click="cikis()" type="danger">GÜVENLİ ÇIKIŞ</van-button> -->
        <van-button size="large" @click="cikis()" type="danger">GÜVENLİ ÇIKIŞ</van-button>

  </div>
</template>

<script>


export default {
  data() {
    return {
      hesap : this.$store.getters.getHesap ,
    };
  },
  created(){
    this.$store.commit("setMenu",false)
    this.$store.commit("setLoading",false)


  },
  methods: {
      cikis(){
         this.show = true
          this.$helper.logout();
      },       
        hesaps(){
          this.show = true;
          setTimeout(() => {
          this.$request.get("hesap/"+this.ayar.firmaid+"/"+this.ayar.kid)
          .then(res => {
              this.bolge = res.results[0].bolge
              this.yetki = res.results[0].tip
              this.isim = res.results[0].isim
              this.tel = res.results[0].tel
              this.posta = res.results[0].eposta
              this.password = res.results[0].pass
              this.kadi = res.results[0].kadi
              this.ekip = res.results[0].ekip
          })
          this.isLoading = false;
          this.show=false
          }, 500);
        },
        update(){
          this.show = true;

            let newPost = {
              id : this.ayar.kid,
              telefon : this.tel,
              posta : this.posta,
              pass : this.password
            }
            this.$request.post("updateUser/", newPost)
            .then (res => {
                this.hesaps();
            })
        },
        ajanda(){
          this.show = true;
            let newPost = {
              kodu : this.ayar.kid,
              firma : this.ayar.firmaid,
              alias: this.mesaj,
              tarih: this.date
            }
            this.$request.post("ajanda/", newPost)
            .then (res => {
              Toast('Eklendi');
                this.show = false
            })
        },        

        depogetir(){this.$request.get("depo/"+this.ayar.firmaid).then(res => { 
          for (let i = 0; i < res.results.length; i++) {this.depo.push(res.results[i].alias);}
        })},
        onConfirm(value) {
          localStorage.setItem('did', value)
          this.did = value //this.$request.did();
          Toast.loading({ message: 'Depo Değişiyor', forbidClick: true, loadingType: 'spinner', });
          this.showPicker = false;
        },
        onChange(index) {
          //this.active = index+1;
        },
        formatDate(date) {
          return `${date.getFullYear() + 1}/${date.getMonth()}/${date.getDate()}`;
        },        
        tarihsec(date) {
          this.show = false;
          this.date = this.formatDate(date);
    },

  },
};
</script>


// WEBPACK FOOTER //
// src/views/hesap.vue